sn-features-type-1 {
  features-card-type-4 {
    width: 100%;
  }

  .features-type-11__cards--dual {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-2xl);

    @include above(960px) {
      flex-direction: row;
    }

    features-card-type-4 {
      flex: 1;
      min-width: 0;
    }
  }

  .features-type-1__cards--dual {
    display: flex;
    align-items: stretch;

    features-card-type-4 {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }

  .features-card-type-4 {
    border-radius: map-get($border-radii, lg);
    display: flex;
    flex-direction: column;
    height: 100%;

    .features-card__info {
      flex: 1;
      display: flex;
      flex-direction: column;

      me-heading {
        margin-bottom: map-get($spacings, lg);

        @include desktop {
          margin-bottom: 0;
        }
      }
    }

    .features-card__image {
      display: flex;
      flex-direction: column;
    }

    // Keep ghost underline width equal to text width.
    // Underline width should track text only, excluding icon gap.
    .me-button--ghost.me-button--icon-after {
      &::before {
        right: calc(#{map-get($spacings, xl)} + #{map-get($spacings, sm)});
      }

      &.is-hovered::before,
      &:hover::before {
        width: calc(100% - (#{map-get($spacings, xl)} + #{map-get($spacings, sm)}));
      }
    }
  }

  .features-card__image {
    padding: 0 map-get($spacings, 4xl) map-get($spacings, 4xl);

    .picture {
      background-color: transparent;
    }
  }


  @include below($breakpoint-desktop-md - 1px) {
    .features-card-type-4--security .picture {
      aspect-ratio: auto !important; // Fix to remove style aspect ration in features-type-4 without touch base component
    }

    .features-card-type-4--primary {
      .features-card-type-4 .features-card__info {
        display: contents;
      }

      [slot='heading'] {
        display: block;
        padding: map-get($spacings, xl) map-get($spacings, xl) 0;
      }

      [slot='actions'] {
        order: 1;
        padding: 0 map-get($spacings, xl) map-get($spacings, xl);
      }
    }
  }

  .apps {
    display: flex;
    flex-wrap: wrap;
    margin: 28px -9px 0;

    @media (width >= 768px) {
      margin: 23px -3px 0 -7px;
    }

    @media (width >= 1024px) {
      margin: 28px -14px 0 -10px;
    }

    @media (width >= 1440px) {
      margin: 40px -16px 0;
    }
  }

  .apps__item {
    width: 33.3333%;
    margin-bottom: 18px;
    padding: 0 8px;

    @media (width >= 768px) {
      margin-bottom: 12px;
      padding: 0 6px;
    }

    @media (width >= 1024px) {
      margin-bottom: 18px;
      padding: 0 9px;
    }

    @media (width >= 1440px) {
      margin-bottom: 25px;
      padding: 0 13px;
    }

    &.apps__item--double-size {
      width: 66.666%;
    }
  }

  .apps__wrapper {
    position: relative;
    background: white;
    box-shadow: 0 6px 20px rgb(0 0 0 / 10%);
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 84px;
    transition: all 0.3s ease;

    @media (width >= 768px) {
      min-height: 70px;
    }

    @media (width >= 1024px) {
      min-height: 105px;
      height: 105px;
      border-radius: 8px;
    }

    @media (width >= 1440px) {
      min-height: 146px;
      height: 146px;
      border-radius: 12px;
    }

    &:hover {
      box-shadow: 0 2px 12px rgb(0 0 0 / 10%);
    }
  }

  .apps__link {
    position: absolute;
    z-index: 1;
    inset: 0;
    border-radius: 12px;
  }

  .apps__logo {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .apps__icon {
    &.apps__icon--gdrive,
    &.apps__icon--gdrive img {
      width: 40px;
      height: 35px;

      @media (width >= 768px) {
        width: 32px;
        height: 28px;
      }

      @media (width >= 1024px) {
        width: 47px;
        height: 42px;
      }

      @media (width >= 1440px) {
        width: 66px;
        height: 58px;
      }
    }

    &.apps__icon--ms-teams,
    &.apps__icon--ms-teams img {
      width: 44px;
      height: 44px;

      @media (width >= 768px) {
        width: 36px;
        height: 36px;
      }

      @media (width >= 1024px) {
        width: 53px;
        height: 53px;
      }

      @media (width >= 1440px) {
        width: 74px;
        height: 74px;
      }
    }

    &.apps__icon--ms-word,
    &.apps__icon--ms-word img {
      width: 37px;
      height: 35px;

      @media (width >= 768px) {
        width: 30px;
        height: 28px;
      }

      @media (width >= 1024px) {
        width: 45px;
        height: 42px;
      }

      @media (width >= 1440px) {
        width: 62px;
        height: 58px;
      }
    }

    &.apps__icon--salesforce {
      width: 53px;
      height: 37px;

      @media (width >= 768px) {
        width: 43px;
        height: 30px;
      }

      @media (width >= 1024px) {
        width: 64px;
        height: 45px;
      }

      @media (width >= 1440px) {
        width: 89px;
        height: 62px;
      }
    }

    &.apps__icon--netsuite,
    &.apps__icon--netsuite img {
      width: 118px;
      height: 30px;

      @media (width >= 768px) {
        width: 95px;
        height: 24px;
      }

      @media (width >= 1024px) {
        width: 142px;
        height: 36px;
      }

      @media (width >= 1440px) {
        width: 197px;
        height: 50px;
      }
    }
  }
}
